import { post, getPYWBackend, postPYWBackend } from 'utils/apiHelper'

export const logoutUser = () =>
  postPYWBackend({
    path: '/email-notification/api/recipient/logout-user',
    config: { withCredentials: true },
  })

export const registerUser = (body) =>
  post({
    path: `/registerGlobalUser`,
    body,
  })

export const updateFullName = (firstName, lastName) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/update-user-profile`,
    body: { update: 'name', firstName, lastName },
  })

export const getUserProfile = (prn) =>
  getPYWBackend({
    path: `/email-notification/api/recipient/get-user-profile`,
    config: {
      withCredentials: true,
      headers: {
        prn,
      },
    },
  })

export const getUserPreferences = (prn) =>
  getPYWBackend({
    path: `/email-notification/api/recipient/get-user-preferences`,
    config: {
      withCredentials: true,
      headers: {
        prn,
      },
    },
  })

export const updateUserPreferences = (prefName, prefValue) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/update-user-profile`,
    body: {
      update: 'preference',
      preferenceKey: prefName,
      preferenceValue: prefValue,
    },
  })

export const updateUserEmail = (updatedEmail) =>
  postPYWBackend({
    path: `/email-notification/api/recipient/update-user-profile`,
    body: {
      update: 'emailAddressReset',
      emailAddress: updatedEmail,
    },
  })

export const updateOtpVerifiedTimestamp = () =>
  postPYWBackend({
    path: `/email-notification/api/recipient/update-otp-verified-at`,
    body: {
      update: 'otpVerifiedTimestamp',
    },
  })
